export default __webpack_public_path__ + "static/068-80b6b94d411d105cffb913494bed390a.jpg";